import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import injectSheet from 'react-jss';

class ApplicationToggle extends React.Component {
    onClick = () => {
        const { onClick, code } = this.props;
        onClick(code);
    };

    render() {
        const { isActive, label, classes } = this.props;
        return (
            <FormControlLabel
                className={classes.checkbox}
                control={
                    <Checkbox
                        color="primary"
                        checked={isActive}
                        onChange={this.onClick}
                    />
                }
                label={label}
            />
        );
    }
}

ApplicationToggle.propTypes = {
    isActive: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    code: PropTypes.string.isRequired,
};

const style = () => ({
    checkbox: {
        marginLeft: '0px',
    },
});

export default injectSheet(style)(ApplicationToggle);



// WEBPACK FOOTER //
// ./src/components/visibleInApplications/ApplicationToggle.js